import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Card from 'react-bootstrap/Card';

type CallingProps = {
  facility: Facility;
};

const Calling: React.FC<CallingProps> = (props) => {
  return (
    <Card>
      <Card.Header>Dialing Instructions</Card.Header>
      <Card.Body>
        <pre>{props.facility.dialingInstructions}</pre>
      </Card.Body>
    </Card>
  );
};

export default Calling;